import React from "react";
import { SessionHistory } from "components/pages/Educator/Session/SessionHistory";

export const AdminSessionHistory = ({ selectedEducator, sharedClassId, onClassChange }) => {
  if (!selectedEducator) return null;
  return (
    <SessionHistory
      key={selectedEducator.id}
      educatorId={selectedEducator.id}
      sharedClassId={sharedClassId}
      onClassChange={onClassChange}
    />
  );
};
